import React from 'react';

import { DetailedCellProps } from '@bringg-frontend/monitoring';
import { ResponseItem } from '@bringg/types';
import { getRootEnv } from '@bringg-frontend/bringg-web-infra';
import { getActionableWaypoint } from '@bringg-frontend/global-stores';
import { LayoutType, getFormattedTimeWindow } from '@bringg/react-components';
import { observer } from 'mobx-react-lite';

import { useStores } from 'bringg-web/recipes';
import { timezoneProvider } from 'bringg-web/services/timezone/timezone-provider';

const TimeWindowCell = ({ row }: DetailedCellProps<ResponseItem>) => {
	const { id } = row;
	const {
		merchantConfigurationsStore: { hourStringFormat }
	} = useStores();

	const task = getRootEnv().dashboardSdk.sdk.v2.tasks.get(id);
	const wp = getActionableWaypoint(task);
	const timezone = timezoneProvider.getTimezoneByTask(task);

	if (!wp || !wp.no_earlier_than || !wp.no_later_than) {
		return <>-- : --</>;
	}

	return (
		<>
			{getFormattedTimeWindow(
				wp.no_earlier_than,
				wp.no_later_than,
				hourStringFormat,
				timezone,
				LayoutType.INLINE
			)}
		</>
	);
};

export default observer(TimeWindowCell);
